import React, { useState } from "react";
import { Phone } from "lucide-react";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  return (
    <section id="contact" className="contactSection">
      <div className="contactContainer">
        <h2 className="contactTitle">Contact</h2>

        <div className="contactContent">
          <div className="phoneSection">
            <div className="phoneNumber">
              <Phone size={24} />
              <span>+91 9600900658</span>
            </div>
          </div>

          <div className="contactCard">
            <form className="contactForm" onSubmit={handleSubmit}>
              <div className="formGroup">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="formInput"
                  required
                />
              </div>

              <div className="formGroup">
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile Number"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  className="formInput"
                  required
                />
              </div>

              <div className="formGroup">
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="formTextarea"
                  rows="4"
                  required
                />
              </div>

              <button type="submit" className="submitButton">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
